import React, { useEffect } from "react";
import { getDistributorDataApi } from "actions/distributorActions";

const SearchPlaceholder = ({ distributor, keyword, api, handleDistributorResponse }) => {
  const onLoad = async () => {
    // console.log({ keyword, distributor, api });
    if (keyword.trim() != "") {
      const data = await getDistributorDataApi(api, keyword);
      if (data) handleDistributorResponse(distributor, data);
    }
  };

  useEffect(() => {
    onLoad();
  }, [keyword]);

  return <></>;
};

export default SearchPlaceholder;
